var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelledActivityGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#616161"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 6,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_9578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5L7 11.5",
    stroke: "#616161",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5L11 11.5",
    stroke: "#616161",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_9578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelledActivityGrey);
export default __webpack_public_path__ + "static/media/Icon_CancelledActivity_Grey.5a412ed5e1565c2ea816ddd814b3a4b4.svg";
export { ForwardRef as ReactComponent };